import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=d8cba66e&scoped=true&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&id=d8cba66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cba66e",
  null
  
)

export default component.exports